// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"805c7100","138":"e2e89617","270":"dd666a81","387":"4d61303c","404":"7dae82bf","488":"b2a64b34","545":"1208605a","580":"2519f665","686":"b40ee481","706":"44ba4c26","728":"ce9c79d7","801":"1f3bccff","888":"861e90f5"}[chunkId] + ".chunk.js";
};